import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e948d67"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "InvoiceContentServices"
}
const _hoisted_2 = { class: "InvoiceContentServices__title" }
const _hoisted_3 = { class: "InvoiceContentServices__content" }
const _hoisted_4 = { class: "InvoiceContentServices__row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "InvoiceContentServices__check" }, "✓", -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "InvoiceContentServices__placeholder" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "InvoiceContentServices__row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContentServices__placeholder" }, "Кубатура упаковки", -1))
const _hoisted_11 = { class: "InvoiceContentServices__row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContentServices__placeholder" }, "Ссылка на списание", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services, (service, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `${_ctx.key}-${i}`,
              class: "InvoiceContentServices__row-holder"
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", null, _toDisplayString(service.type_name), 1),
                _hoisted_5
              ]),
              (_ctx.isVisibleServiceExtended(service.type_code))
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.INVOICE_ADDITIONALL_SERVICES_EXTENDED_BLOCKS, (block, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `block-${i}-${idx}`,
                        class: "InvoiceContentServices__row"
                      }, [
                        _createElementVNode("p", _hoisted_7, _toDisplayString(block.name), 1),
                        _createElementVNode("p", null, _toDisplayString(service[block.key] || '-'), 1)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isVisibleServiceTMC(service.type_id))
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("p", null, _toDisplayString(_ctx.getServiceTmc(service.type_id, 'cubature')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createVNode(_component_router_link, {
                        class: "InvoiceContentServices__link",
                        to: `/tmc/write-offs/${_ctx.getServiceTmc(service.type_id, 'link')}`,
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Открыть списание ")
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}